import { render, staticRenderFns } from "./GeneBody.vue?vue&type=template&id=c17876b6&scoped=true&"
import script from "./GeneBody.vue?vue&type=script&lang=js&"
export * from "./GeneBody.vue?vue&type=script&lang=js&"
import style0 from "./GeneBody.vue?vue&type=style&index=0&id=c17876b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17876b6",
  null
  
)

export default component.exports